import React, { useState } from 'react';
import { Header, Footer } from './Container';
import { Container } from "react-bootstrap";
import ProfileUpdate from './features/ProfileUpdate';
import ProfilePage from './features/ProfilePage';

function Profile() {
    const [edit, setEdit] = useState(false);
    const _handleEdit = () => {
        setEdit(!edit);
    };
    return (
        <Container fluid="true">
            <Header type="client" />
            {edit ? <ProfileUpdate _handleEdit={_handleEdit} /> : <ProfilePage _handleEdit={_handleEdit} />}
            <Footer />
        </Container>
    );
}

export default Profile;
